import React, { useEffect, useRef, useState } from "react";
import propTypes from "prop-types";
import flex from "../../../../styles/flex";
import { Button, TextField } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";


const NumberSpinnerInputField: React.FunctionComponent<{
    label: string,
    value?: number;
    maxWidth?: number;
    min?: number;
    max?: number;
    multiLineLabel?: boolean;
    onChange: (value: number) => void;
}> = (props) => {
    const ref = useRef<HTMLInputElement>();

    const formatValue = (value: number | string | null | undefined) => {
        return parseInt((value == null ? "0" : value.toString())).toString();
    }

    const [value, setValue] = useState<string>(formatValue(props.value));
    const valueAsNumber = Number(value);

    useEffect(() => {
        setValue(formatValue(props.value));
    }, [props.value]);

    const decreaseValueHandler = () => {
        if ((props.min === 0 || props.min) && (valueAsNumber - 1) < props.min) { //have to check for 0 specifically as it is classed as falsy
            return;
        }

        props.onChange(valueAsNumber - 1)
    }

    const increaseValueHandler = () => {
        if (props.max && (valueAsNumber + 1) > props.max) {
            return;
        }

        props.onChange(valueAsNumber + 1)
    }

    return (
        <div style={flex.flexRows}>
            <Button size="small" variant="outlined" style={{ minWidth: '30px', borderTopRightRadius: "0", borderBottomRightRadius: "0", borderColor: "lightgray" }} onClick={(decreaseValueHandler)}><Remove fontSize="small" /></Button>
            <TextField
                inputRef={ref}
                type="number"
                size="small"
                disabled={true}
                label={props.label}
                variant="outlined"
                style={
                    { maxWidth: props.maxWidth }
                }
                value={value}
                sx={{
                    '& .MuiInputBase-input.Mui-disabled': {
                        color: 'black',
                        WebkitTextFillColor: 'black', // for Safari
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderLeft: 'none',
                        borderRight: 'none',
                        borderRadius: 0,
                    }
                }}
                InputLabelProps={{
                    style: { transform: `${props.multiLineLabel ? 'translate(14px, -15px) scale(0.75)' : ''}` },
                    shrink: true,
                    sx: {
                        '&.Mui-disabled': {
                            color: 'rgba(0, 0, 0, 0.54)'
                        }
                    },
                }}
                InputProps={{
                    sx: {
                        '&.MuiInputBase-input': {
                            color: 'black'
                        },
                        '&.Mui-disabled': {
                            color: 'rgba(0, 0, 0, 0.54)'
                        }
                    },
                }}
                onChange={(e) => {
                    setValue(e.target.value);
                }}
                onBlur={(e) => {
                    const val = parseFloat(e.target.value);
                    if (isNaN(val)) {
                        if (ref.current) {
                            ref.current.value = props.value == null ? "0" : props.value.toString();
                        }
                        return;
                    }
                    setValue(e.target.value);
                    props.onChange(val);
                }}
            />
            <Button size="small" variant="outlined" style={{ minWidth: "30px", borderTopLeftRadius: "0", borderBottomLeftRadius: "0", borderColor: "lightgray" }} onClick={(increaseValueHandler)}><Add fontSize="small" /></Button>
        </div>
    );
}
NumberSpinnerInputField.propTypes = {
    label: propTypes.string.isRequired,
    value: propTypes.number,
    onChange: propTypes.func.isRequired,
    maxWidth: propTypes.number,
    min: propTypes.number,
    max: propTypes.number,
    multiLineLabel: propTypes.bool
}

export default NumberSpinnerInputField;